import { Link } from 'react-router-dom';
import { BrandMark } from './BrandMark.js';

export function PublicNav() {
  return (
    <header className="public-nav">
      <div className="public-nav__primary">
        <Link to="/" className="public-nav__brand">
          <BrandMark />
        </Link>
        <Link to="/login" className="public-nav__sign-in public-nav__sign-in--mobile">
          Sign In
        </Link>
      </div>
      <nav className="public-nav__links" aria-label="Marketing">
        <a href="/#features">Features</a>
        <a href="/#how-it-works">How It Works</a>
        <Link to="/login" className="public-nav__sign-in public-nav__sign-in--desktop">
          Sign In
        </Link>
        <Link to="/request-demo" className="btn btn--primary btn--sm public-nav__cta">
          Request a Demo
        </Link>
      </nav>
    </header>
  );
}
